module.exports = {"app.title":"ERS Profile","app.login":"Login","app.login.loggedIn":"Logged in as: {name}","app.login.logout":"Logout","app.cancel":"Cancel","app.username":"Username","app.password":"Password","app.accounts.title":"Accounts","app.accounts.name":"Name","app.accounts.accountType":"Account Type","app.accounts.primaryContact":"Primary Contact","entityList.search":"Search","entityList.noResults":"No Results"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/lang/en-US.json
// module id = 6447
// module chunks = 0